

export default function UbicacionCompoent() {
    return (
        <section id='ubicacion'>
            <div className='franja'>
                <p>MAPA DE UBICACIÓN</p>
            </div>
            <div className='mapa'>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3112.2902542698935!2d-72.59341813945302!3d-38.73410112968154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9614d3e845b520a5%3A0x5bc3399cc175dc81!2sPatricio%20Lynch%20146%2C%20Temuco%2C%20Araucan%C3%ADa!5e0!3m2!1ses-419!2scl!4v1696434679565!5m2!1ses-419!2scl"></iframe>
            </div>
            <div className='info-ubicacion'>
                <div className='datos'>
                    <div className='dato dato-uno'>
                        <p>Visita nuestro Piloto en <strong>Calle Lynch 146 - Temuco</strong></p>
                    </div>
                    <div className='dato dato-dos'>
                        <p>Llámanos y te asesoramos<strong>+ 56 9 5047 2234</strong></p>
                    </div>
                </div>

                <div className='redes'>
                    <p>Búscanos <span>también en</span></p>
                    <a href="https://www.facebook.com/almirantecl">
                        <img
                            src="/images/home/icono_11_celular.png"
                            alt="icono_1_celular"
                        />
                    </a>
                    <a href="https://www.instagram.com/edificioalmirante/">
                        <img
                            src="/images/home/icono_12_celular.png"
                            alt="icono_1_celular"
                        />
                    </a>
                </div>
            </div>
        </section>
    )
}